<template>
  <div class="switch-quality" tabindex="-1">
    <input
      id="sd"
      v-tealium:click="$stats.fip.onSwitchQuality(qualities.SD)"
      :checked="selectedQuality === qualities.SD"
      :disabled="!definitions.SD"
      data-wptv="banniere-SD"
      type="radio"
      name="quality"
      value="sd"
      tabindex="0"
      class="switch-input"
      @click="$emit('select', qualities.SD)">

    <label
      :aria-label="$t('fip.accessibility.qualities.sd')"
      for="sd"
      tabindex="0"
      class="switch-label"
      @keyup.enter="$emit('select', qualities.SD)">
      <span>
        {{ qualities.SD }}
      </span>
    </label>

    <input
      id="hd"
      v-tealium:click="$stats.fip.onSwitchQuality(qualities.HD)"
      :checked="selectedQuality === qualities.HD"
      :disabled="!definitions.HD"
      data-wptv="banniere-HD"
      type="radio"
      name="quality"
      tabindex="0"
      value="hd"
      class="switch-input"
      @click="$emit('select', qualities.HD)">

    <label
      :aria-label="$t('fip.accessibility.qualities.hd')"
      for="hd"
      tabindex="0"
      class="switch-label switch-label-right"
      @keyup.enter="$emit('select', qualities.HD)">
      <span>
        {{ qualities.HD }}
      </span>
    </label>

    <span class="switch-selection" />
  </div>
</template>

<script>
export default {
  name: 'SwitchQuality',
  props: {
    definitions: {
      type: Object,
      required: true
    },
    selectedQuality: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      qualities: {
        SD: 'SD',
        HD: 'HD'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .switch-quality {
    position: relative;
    border: 2px solid $altlightgrey;
    border-radius: 25px;
    display: flex;
    background: $black;

      .switch-label {
        position: relative;
        z-index: 2;
        float: left;
        height: 30px;
        width: 37px;
        font-size: 12px;
        color: $grey;
        font-weight: bold;
        margin: 0 !important;
        cursor: pointer;
        @extend %focus-visible;

        &:active {
          font-weight: bold;
        }

        > span {
          display: flex;
          position: absolute;
          width: 100%;
          top: 50%;
          text-align: center;
          justify-content: center;
          transform: translateY(-50%);
          line-height: 1;
          @extend %focus-visible;
        }
      }

      .switch-input {
        display: none;
        @extend %focus-visible;
      }

      .switch-input:checked + .switch-label {
        color: $black;
      }

      .switch-input:checked + .switch-label-right ~ .switch-selection {
        left: 37px;
      }

      .switch-selection {
        position: absolute;
        z-index: 1;
        top: 2px;
        left: 2px;
        display: block;
        height: 26px;
        width: 35px;
        border-radius: 13px;
        background-color: $white;
        transition: left 0.15s ease-out;
        @extend %focus-visible;
    }
  }
</style>
